module.exports = __webpack_public_path__ + "static/media/linux-logo.993d981b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/linux-logo.png
// module id = 396
// module chunks = 0